import { AUDIT } from "../const"
import request from "../utils/request"

const getAuditLog = (params: any) => {
  return request.post(`${AUDIT.getAuditLog}`, { data: params })
}

const getAuditDetail = (params: any) => {
  return request.post(`${AUDIT.getAuditDetail}`, { data: params })
}

const getRelationshipInfo = (params: any) => {
  return request.post(`${AUDIT.getRelationshipInfo}`, { data: params })
}

const getHealthQuestion = (params: any) => {
  return request.get(`${AUDIT.getHealthQuestion}`, { params })
}

const addAuditLog = (params: any) => {
  return request.post(`${AUDIT.addAuditLog}`, { data: params })
}

const getProductInfo = (params: any) => {
  return request.get(`${AUDIT.getProductInfo}`, { params })
}

const getAuditInsureFileItem = (params: any) => {
  return request.get(`${AUDIT.getAuditInsureFileItem}`, { params })
}

const downLoadAuditFiles = (params: any) => {
  // return request.post(`${AUDIT.downLoadAuditFiles}`,{data:params});
  return request.get(AUDIT.downLoadAuditFiles, {
    responseType: "blob",
    params,
  })
}

const getAuditSpeed = (params: any) => {
  return request.post(`${AUDIT.getAuditSpeed}`, { data: params })
}

const getProblemFileInfo = (params: any) => {
  return request.get(`${AUDIT.getProblemFileInfo}`, { params })
}

const getHistoryAudit = (params: any) => {
  return request.post(`${AUDIT.getHistoryAudit}`, { data: params })
}

export {
  getAuditDetail,
  getRelationshipInfo,
  getHealthQuestion,
  getAuditLog,
  addAuditLog,
  getProductInfo,
  getAuditInsureFileItem,
  downLoadAuditFiles,
  getAuditSpeed,
  getProblemFileInfo,
  getHistoryAudit,
}
